import { Mail, Phone } from 'lucide-react'
import { ReactNode } from 'react'
import { FaFacebook, FaInstagram, FaTiktok, FaWhatsapp, FaYoutube } from 'react-icons/fa'

import LanguageChanger from '@/blocks/components/LanguageSwitcher'
import { AcademyPublicDto } from '@/server/public-api/types'

const HeaderTop = ({ academy }: { academy: AcademyPublicDto }) => {
  const headerLeft = [
    academy.contact.email && {
      href: `mailto:${academy.contact.email}`,
      icon: <Mail className='size-4 sm:size-6 ' />,
      text: academy.contact.email,
    },
    academy.contact.phone && {
      href: `tel:${academy.contact.phone}`,
      icon: <Phone className='size-4 sm:size-6 ' />,
      text: academy.contact.phone,
    },
  ].filter(Boolean) as { href: string; icon: ReactNode; text: string }[]

  const headerRight = [
    academy.contact.whatsapp && {
      href: `https://wa.me/${academy.contact.whatsapp.replace(/\+/g, '')}`,
      label: 'WhatsApp',
      icon: <FaWhatsapp className='size-4 hover:text-[#25D366] sm:size-6 ' />,
    },
    academy.socials.facebook && {
      href: academy.socials.facebook,
      label: 'Facebook',
      icon: <FaFacebook className='size-4 hover:text-[#4267B2] sm:size-6 ' />,
    },
    academy.socials.tiktok && {
      href: academy.socials.tiktok,
      label: 'TikTok',
      icon: <FaTiktok className='size-4 hover:text-[#ff0000] sm:size-6 ' />,
    },
    academy.socials.youtube && {
      href: academy.socials.youtube,
      label: 'YouTube',
      icon: <FaYoutube className='size-4 hover:text-[#ff0000] sm:size-6 ' />,
    },
    academy.socials.instagram && {
      href: academy.socials.instagram,
      label: 'Instagram',
      icon: <FaInstagram className='size-4 hover:text-[#405DE6] sm:size-6 ' />,
    },
  ].filter(Boolean) as { href: string; label: string; icon: ReactNode }[]

  return (
    <section className='flex min-h-12 items-center bg-secondary'>
      <div className='container flex justify-between'>
        <ul className='flex items-center gap-3 text-xl font-medium text-white sm:gap-6'>
          {headerLeft.map((item, index) => (
            <li key={index}>
              <a
                href={item.href}
                aria-label={item.text}
                className='flex items-center gap-2 text-xl font-medium text-white'
              >
                {item.icon}
                <span className='hidden md:inline-block'>
                  {/* `+` is a bidi-NEUTRAL character, so in an Arabic (RTL) paragraph it
                      resolves to the paragraph direction and paints to the RIGHT of the
                      digits: `+201044206918` is drawn as `201044206918+`. `<bdi>` isolates
                      the value from the surrounding run and `dir='ltr'` pins it. */}
                  <bdi dir='ltr'>{item.text}</bdi>
                </span>
              </a>{' '}
            </li>
          ))}
        </ul>
        <div className='flex items-center gap-2 sm:gap-4'>
          <ul className='flex gap-3 text-xl font-medium text-white sm:gap-6'>
            {headerRight.map((item, index) => (
              <li key={index}>
                <a
                  href={item.href}
                  aria-label={item.label}
                  className='flex items-center gap-2 text-xl font-medium text-white'
                  target='_blank'
                  rel='noreferrer'
                >
                  {item.icon}
                </a>
              </li>
            ))}
          </ul>
          <LanguageChanger supportedLocales={academy.supportedLanguages} />
        </div>
      </div>
    </section>
  )
}

export default HeaderTop
